<template>
  <div class="help-center">
    <div class="help-card">
      <v-btn block outlined color="indigo" class="my-btn help-btn" @click="goPage">Help Center</v-btn>
      <div class="contact">
        <div class="contact_item">
          <div class="icon-wrap">
            <img class="email" src="/imgs/email_m.png" alt="Email Img" />
          </div>
          <a class="info_text link-url" href="mailto:stylool&#64;outlook.com">stylool&#64;outlook.com</a>
        </div>
        <div class="contact_divider"></div>
        <div class="contact_item">
          <div class="icon-wrap">
            <img src="/imgs/livechat_m.png" alt="Live Chat Img" />
          </div>
          <a class="info_text link-url" @click="openChat">Live Chat</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LmobileHelp',
  methods: {
    goPage() {
      this.$router.push({
        name: 'index-faq-articles',
        params: { articles: 'list' }
      })
    },
    openChat() {
      // eslint-disable-next-line no-undef
      if (FB) {
        // eslint-disable-next-line no-undef
        FB.CustomerChat.showDialog()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.help-center {
  padding: 0 16px 24px;
}
.help-card {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 16px;
  padding: 20px 18px;
  border: 1px solid rgba(48, 103, 242, 0.06);
  box-shadow: 0 2px 16px rgba(48, 103, 242, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  .help-btn {
    height: 46px;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.3px;
    border-radius: 12px;
    border: 2px solid #3067f2;
    color: #3067f2;
    background: transparent;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    &:hover {
      background: #3067f2;
      color: #fff;
      box-shadow: 0 4px 16px rgba(48, 103, 242, 0.3);
    }
  }
  .contact {
    margin-top: 16px;
    padding: 0;
    .contact_item {
      display: flex;
      align-items: center;
      padding: 8px 0;
      .icon-wrap {
        width: 32px;
        height: 32px;
        border-radius: 10px;
        background: rgba(48, 103, 242, 0.06);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 14px;
        flex-shrink: 0;
      }
      img {
        width: 15px;
        height: 15px;
        object-fit: contain;
      }
      .email {
        width: 17px;
      }
      .info_text {
        color: #3a3f51;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.2px;
        text-decoration: none;
        transition: color 0.2s ease;
        &:hover {
          color: #3067f2;
        }
      }
    }
    .contact_divider {
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(48, 103, 242, 0.08), transparent);
      margin: 2px 0;
    }
  }
}
</style>
